import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import ReactExifOrientationImg from 'react-exif-orientation-img'

import styles from './Image.module.scss'

// export default class Image extends React.Component {
//   constructor(props) {
//     super(props)

//     this.state = {
//       src: props.src,
//     }
//   }

//   componentWillReceiveProps(nextProps: Props) {
//     this.setState({ src: nextProps.src })
//   }

//   render() {
//     const { alt, background, className, cover, fit, full, src: propsSrc, ...others } = this.props
//     const { src } = this.state

//     return (
//       <div className={classNames(styles.wrap, background && styles['wrap---background'])}>
//         <ReactExifOrientationImg
//           {...others}
//           alt={alt}
//           src={src || propsSrc}
//           className={classNames(
//             'Image',
//             styles.this,
//             fit && styles[`this---${fit}`],
//             full && styles['this---full'],
//             className,
//           )}
//         />
//       </div>
//     )
//   }
// }

export default function Image({ alt, background, className, cover, fit, full, ...others }: props) {
  return (
    <div className={classNames(styles.wrap, background && styles['wrap---background'])}>
      <ReactExifOrientationImg
        {...others}
        alt={alt}
        className={classNames(
          'Image',
          styles.this,
          fit && styles[`this---${fit}`],
          full && styles['this---full'],
          className,
        )}
      />
    </div>
  )
}

Image.propTypes = {
  alt: PropTypes.string,
  background: PropTypes.bool,
  className: PropTypes.string,
  cover: PropTypes.bool,
  fit: PropTypes.oneOf(['contain', 'cover']),
  full: PropTypes.bool,
  src: PropTypes.string,
}

Image.defaultProps = {
  alt: '',
}



// WEBPACK FOOTER //
// ./src/components/Image/Image.js